import { Data_getInstance3ewpgkyxu18rh as Data_getInstance } from './adapter/DeletePlayerMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { DeletePlayerMutationSelections_getInstance3idtj6h29uhfu as DeletePlayerMutationSelections_getInstance } from './selections/DeletePlayerMutationSelections.mjs';
import { DeletePlayerMutation_VariablesAdapter_instance1maulzzwwk3y9 as DeletePlayerMutation_VariablesAdapter_instance } from './adapter/DeletePlayerMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deletePlayer) {
        this.a6j_1 = deletePlayer;
      }
      toString() {
        return 'Data(deletePlayer=' + this.a6j_1 + ')';
      }
      hashCode() {
        return this.a6j_1 == null ? 0 : getBooleanHashCode(this.a6j_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.a6j_1 == other.a6j_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.b6j_1 = obj(Data_getInstance());
        this.c6j_1 = (new (Builder())('data', Companion_getInstance().g6h_1)).p46(DeletePlayerMutationSelections_getInstance().f6j_1).e3a();
        this.d6j_1 = '325dc987fdb63884ec22f9791902a751f93a10868d54c5276b03653e11ea6dc8';
        this.e6j_1 = 'deletePlayer';
      }
      j6h() {
        return 'mutation deletePlayer($input: DeletePlayerInput!) { deletePlayer(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DeletePlayerMutationClass;
function DeletePlayerMutation() {
  if (DeletePlayerMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.g6j_1 = input;
      }
      l6h() {
        return '325dc987fdb63884ec22f9791902a751f93a10868d54c5276b03653e11ea6dc8';
      }
      operationId() {
        return this.l6h();
      }
      i4a() {
        return Companion_getInstance_0().j6h();
      }
      m6h() {
        return 'deletePlayer';
      }
      operationName() {
        return this.m6h();
      }
      m49(writer, customScalarAdapters, withDefaultValues) {
        DeletePlayerMutation_VariablesAdapter_instance.h6j(writer, this, customScalarAdapters, withDefaultValues);
      }
      l49() {
        return Companion_getInstance_0().b6j_1;
      }
      toString() {
        return 'DeletePlayerMutation(input=' + this.g6j_1.toString() + ')';
      }
      hashCode() {
        return this.g6j_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePlayerMutation()))
          return false;
        if (!this.g6j_1.equals(other.g6j_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePlayerMutation', VOID, VOID, [Mutation()]);
    DeletePlayerMutationClass = $;
  }
  return DeletePlayerMutationClass;
}
//region block: exports
export {
  Data as Data1yeuamf60pgqe,
  DeletePlayerMutation as DeletePlayerMutation1lewkfyyqx4x0,
};
//endregion

//# sourceMappingURL=DeletePlayerMutation.mjs.map
